import type { Disposable } from "@/shared/contracts/lifecycle";
import type { HoverPointerModel } from "./hoverPointerModel";
import type { HoverPointerSnapshot } from "./hoverPointerTypes";

export class HoverPointerView implements Disposable {
  readonly root: HTMLDivElement;
  private readonly unsubscribe: () => void;

  constructor(model: HoverPointerModel) {
    this.root = document.createElement("div");
    this.root.className = "hover-idle-virtual-pointer";
    this.root.dataset.visible = "false";
    this.root.setAttribute("aria-hidden", "true");

    this.applySnapshot(model.getSnapshot());
    this.unsubscribe = model.subscribe((snapshot) => {
      this.applySnapshot(snapshot);
    });
  }

  private applySnapshot(snapshot: HoverPointerSnapshot): void {
    const visible =
      snapshot.kind === "virtualTouch" && snapshot.position !== null;
    this.root.dataset.visible = visible ? "true" : "false";
    if (visible && snapshot.position !== null) {
      this.root.style.transform = `translate(${snapshot.position.x}px, ${snapshot.position.y}px)`;
    }
  }

  dispose(): void {
    this.unsubscribe();
    this.root.remove();
  }
}
